const launcherProviders = {
    FACEBOOK_BANNER: 'facebook_banner',
    FACEBOOK_CAROUSEL: 'facebook_carousel',
    FACEBOOK_STORIES: 'facebook_stories',
    FACEBOOK_CAROUSEL_STORIES: 'facebook_carousel_stories',
    GOOGLE_LOCAL_CAMPAIGNS: 'google_local_campaigns',
};

export default launcherProviders;
